module.exports = __webpack_public_path__ + "static/media/user3.055d1e5b.jpeg";